import type { components } from "@tms/shared/types/generated";

type DriverStatus = components["schemas"]["DriverSummary"]["status"];
type DocumentValidity = components["schemas"]["DriverSummary"]["documentValidity"];
type DriverDocumentKind = components["schemas"]["DocumentView"]["kind"];
type EmploymentForm = components["schemas"]["EmploymentView"]["form"];
type WorkingTimeSystem = NonNullable<components["schemas"]["EmploymentView"]["workingTimeSystem"]>;

const STATUS_LABELS: Record<DriverStatus, string> = {
  ACTIVE: "Czynny",
  ON_LEAVE: "Nieobecny",
  SUSPENDED: "Zawieszony",
  TERMINATED: "Rozwiązana umowa",
};

const DOCUMENT_KIND_LABELS: Record<DriverDocumentKind, string> = {
  DRIVING_LICENCE: "Prawo jazdy",
  DRIVER_QUALIFICATION: "Kwalifikacja wstępna",
  TACHOGRAPH_CARD: "Karta kierowcy",
  MEDICAL_EXAM: "Badanie lekarskie",
  PSYCHOLOGICAL_EXAM: "Badanie psychologiczne",
  ADR_CERTIFICATE: "Zaświadczenie ADR",
  DRIVER_ATTESTATION: "Świadectwo kierowcy",
  WORK_PERMIT: "Zezwolenie na pracę",
  RESIDENCE_DOCUMENT: "Dokument pobytowy",
  ID_DOCUMENT: "Dokument tożsamości",
  A1_CERTIFICATE: "Zaświadczenie A1",
};

const EMPLOYMENT_FORM_LABELS: Record<EmploymentForm, string> = {
  EMPLOYMENT_CONTRACT: "Umowa o pracę",
  MANDATE_CONTRACT: "Umowa zlecenie",
  B2B: "Własna działalność",
};

const WORKING_TIME_LABELS: Record<WorkingTimeSystem, string> = {
  BASIC: "Podstawowy",
  EQUIVALENT: "Równoważny",
  TASK_BASED: "Zadaniowy",
};

export function driverStatusLabel(status: DriverStatus): string {
  return STATUS_LABELS[status];
}

export function documentKindLabel(kind: DriverDocumentKind): string {
  return DOCUMENT_KIND_LABELS[kind];
}

export function employmentFormLabel(form: EmploymentForm): string {
  return EMPLOYMENT_FORM_LABELS[form];
}

export function workingTimeLabel(system: WorkingTimeSystem): string {
  return WORKING_TIME_LABELS[system];
}

export function isHealthExamination(kind: DriverDocumentKind): boolean {
  return kind === "MEDICAL_EXAM" || kind === "PSYCHOLOGICAL_EXAM";
}

export function documentValidityLabel(validity: DocumentValidity, daysToExpiry?: number): string {
  switch (validity) {
    case "VALID":
      return "—";
    case "EXPIRING_SOON":
      return daysToExpiry === undefined ? "wygasa" : `wygasa za ${daysToExpiry} dni`;
    case "EXPIRED":
      return "wygasł";
    case "MISSING":
      return "brak";
  }
}

export const DRIVER_STATUS_OPTIONS = Object.entries(STATUS_LABELS).map(([value, label]) => ({
  value,
  label,
}));
export const DOCUMENT_KIND_OPTIONS = Object.entries(DOCUMENT_KIND_LABELS).map(([value, label]) => ({
  value,
  label,
}));
export const EMPLOYMENT_FORM_OPTIONS = Object.entries(EMPLOYMENT_FORM_LABELS).map(
  ([value, label]) => ({ value, label }),
);
export const WORKING_TIME_OPTIONS = Object.entries(WORKING_TIME_LABELS).map(([value, label]) => ({
  value,
  label,
}));
export const DOCUMENT_VALIDITY_OPTIONS = [
  { value: "VALID", label: "Wszystko ważne" },
  { value: "EXPIRING_SOON", label: "Wygasa w 30 dni" },
  { value: "EXPIRED", label: "Wygasł" },
  { value: "MISSING", label: "Brak dokumentu" },
];
